import React, { useContext, useEffect, useState } from 'react'
import { t, Trans } from '@lingui/macro'
import { ButtonPrimary } from 'front-end/src/components'
import CampaignBannerAction from '../campaign-action/CampaignBannerAction'
import CampaignEmailAction from '../campaign-action/CampaignEmailAction'
import { linkBuilder } from '../../../../../shared/linkBuilder'
import { navigateTo } from '../../../app/util/appHistory'
import CampaignPathwayShareAction from '../campaign-action/CampaignPathwayShareAction'
import CampaignSurveyShareAction from '../campaign-action/CampaignSurveyShareAction'
import { CreateCampaignActionModal } from '../campaign-overview/create-campaign-action-modal/CreateCampaignActionModal'
import DeleteCampaignActionModal from '../campaign-overview/delete-campaign-action-modal/DeleteCampaignActionModal'
import { notification } from '../../../components/common/notifications/Notifications'
import Loader from '../../../components/common/loader/Loader'
import _ from 'lodash'
import './CampaignActions.less'
import { CampaignActionTime } from './CampaignActionTime'
import { ManageCampaignContext, SingleCampaign } from '../ManageCampaignPage'
import IconEnergy from '../../../components/common/icon/IconEnergy'
import CampaignTopicShareAction from '../campaign-action/CampaignTopicShareAction'
import CampaignMessageAction from '../campaign-action/CampaignMessageAction'
import {
  countOfActionsInCampaign,
  isCampaignFixed,
  isCampaignImmediate,
  isCampaignRelative
} from '../utils'
import {
  CampaignBannerModel,
  CampaignCertificationShareActionModelAsEditor,
  CampaignEmailActionModel,
  CampaignMessageActionModel,
  CampaignPathwayShareActionModel,
  CampaignStateEnum,
  CampaignSurveyShareActionModel,
  CampaignTopicShareActionModel
} from 'front-end/src/graphql/private/PrivateSchemaTypes'
import CampaignCertificationShareAction from '../campaign-action/CampaignCertificationShareAction'
import PageHeader from 'front-end/src/components/common/page/header/PageHeader'
import { Box, Flex } from '@chakra-ui/react'
import { css } from '@emotion/react'
import dayjs from 'shared/dayjs'
import IconEmptyCampaigns from 'public/assets/img/empty-campaigns.svg'
import CopyCampaignActionModal from 'front-end/src/pages/manage-campaign-page/campaign-overview/copy-campaign-action-modal/CopyCampaignActionModal'
import { CampaignActionTypeEnum } from 'shared/enums/campaigns'

export type ICampaignAction =
  | CampaignSurveyShareActionModel
  | CampaignMessageActionModel
  | CampaignPathwayShareActionModel
  | CampaignTopicShareActionModel
  | CampaignBannerModel
  | CampaignEmailActionModel
  | CampaignCertificationShareActionModelAsEditor
  | null

export interface ICampaignActionToTriggerChange {
  action: ICampaignAction
  actionType: CampaignActionTypeEnum
}

const INVALID_DATE = new Date('invalid').toString()
function isScheduleTypeWrong(inspected: string): boolean
function isScheduleTypeWrong(inspected: string[]): boolean
function isScheduleTypeWrong(inspected: string | string[]): boolean {
  const checkIsValueWrong = (value: string) =>
    value === 'null' || value === INVALID_DATE
  if (Array.isArray(inspected)) {
    return inspected.some(checkIsValueWrong)
  }
  return checkIsValueWrong(inspected)
}

export const CampaignActions = () => {
  const { campaign, refetchCampaign } = useContext(ManageCampaignContext)
  const { wasCampaignDeactivated } = campaign

  const [showCreateActionModal, setShowCreateActionModal] =
    useState<boolean>(false)

  const [campaignActionToDelete, setCampaignActionToDelete] =
    useState<ICampaignActionToTriggerChange | null>(null)

  const [campaignActionToCopy, setCampaignActionToCopy] =
    useState<ICampaignActionToTriggerChange | null>(null)

  const [showDeleteActionModal, setShowDeleteActionModal] =
    useState<boolean>(false)

  const [showCopyActionModal, setShowCopyActionModal] = useState<boolean>(false)

  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [actionsTimeline, setActionsTimeline] = useState({})
  const [isWrongScheduleType, setIsWrongScheduleType] = useState<boolean>(false)
  const [isDeleting, setIsDeleting] = useState<boolean>(false)

  useEffect(() => {
    setIsLoading(true)

    if (isCampaignFixed(campaign) || isCampaignRelative(campaign)) {
      const timeline = createActionsTimeline(campaign)

      if (isScheduleTypeWrong(Object.keys(timeline))) {
        setIsWrongScheduleType(true)
      } else {
        setIsWrongScheduleType(false)
      }
      setActionsTimeline(timeline)
    } else {
      setActionsTimeline({})
      setIsWrongScheduleType(false)
    }

    setIsLoading(false)

    if (isDeleting) {
      if (
        countOfActionsInCampaign(campaign) === 0 &&
        campaign.status === CampaignStateEnum.DEACTIVATED
      ) {
        notification.warning(
          t`The campaign has been deactivated because it does not contain any actions`
        )
      }
      setIsDeleting(false)
    }
  }, [campaign])

  const Day = (dayProps) => {
    const { day, wrongScheduleType } = dayProps
    if (wrongScheduleType) {
      return (
        <>
          <span className="middle-wrong-schedule">
            <span>&#9888;</span>
          </span>
        </>
      )
    }

    if (isCampaignFixed(campaign)) {
      const formattedTimestamp = dayjs(day)
      const formattedMonth = formattedTimestamp.format('MMM')
      const formattedDay = formattedTimestamp.format('D')
      const formattedYear = formattedTimestamp.format('YYYY')
      return (
        <>
          <span className="top">{formattedMonth}</span>
          <span className="middle">{formattedDay}</span>
          <span className="bottom">{formattedYear}</span>
        </>
      )
    } else {
      return (
        <>
          <span className="top">
            <Trans>Day</Trans>
          </span>
          <span className="middle">{day}</span>
        </>
      )
    }
  }

  const Action = (props: { time: string | null; action: any }) => {
    const { time, action } = props

    // this is a hack, context would be better here
    const actualAction = action[Object.keys(action)[0]]

    if (action.banner || action.bannerHide) {
      const bannerType = action.banner ? action.banner : action.bannerHide

      return (
        <div className="CampaignActions__item">
          <CampaignActionTime timeWithTimezone={time} />

          <div
            key={bannerType.id}
            className={`CampaignActions__action ${
              !!action.bannerHide ? 'CampaignActions__action--disabled' : ''
            }`}
          >
            <CampaignBannerAction
              banner={bannerType}
              onEditClick={() => {
                navigateTo(
                  linkBuilder.campaignBanner(campaign.id, bannerType.id)
                )
              }}
              onDeleteClick={(e) => {
                e.stopPropagation()
                setCampaignActionToDelete({
                  action: bannerType,
                  actionType: CampaignActionTypeEnum.BANNER
                })
                setShowDeleteActionModal(true)
              }}
              bannerHide={!!action.bannerHide}
              onCopyClick={(e) => {
                e.stopPropagation()
                setCampaignActionToCopy({
                  action: bannerType,
                  actionType: CampaignActionTypeEnum.BANNER
                })
                setShowCopyActionModal(true)
              }}
            />
          </div>
        </div>
      )
    }
    if (action.email) {
      return (
        <div className="CampaignActions__item">
          <CampaignActionTime
            smartSchedule={actualAction.automatic_time_of_day}
            timeWithTimezone={time}
          />

          <div key={action.email.id} className="CampaignActions__action">
            <CampaignEmailAction
              email={action.email}
              onEditClick={() => {
                navigateTo(
                  linkBuilder.campaignEmail(campaign.id, action.email.id)
                )
              }}
              onDeleteClick={(e) => {
                e.stopPropagation()
                setCampaignActionToDelete({
                  action: action.email,
                  actionType: CampaignActionTypeEnum.EMAIL
                })
                setShowDeleteActionModal(true)
              }}
              onCopyClick={(e) => {
                e.stopPropagation()
                setCampaignActionToCopy({
                  action: action.email,
                  actionType: CampaignActionTypeEnum.EMAIL
                })
                setShowCopyActionModal(true)
              }}
            />
          </div>
        </div>
      )
    }
    if (action.topicShareAction) {
      return (
        <div className="CampaignActions__item">
          <CampaignActionTime
            timeWithTimezone={time}
            smartSchedule={actualAction.automatic_time_of_day}
          />
          <div
            key={action.topicShareAction.id}
            className="CampaignActions__action"
          >
            <CampaignTopicShareAction
              topicShareAction={action.topicShareAction}
              onEditClick={() => {
                navigateTo(
                  linkBuilder.campaignTopicShareAction(
                    campaign.id,
                    action.topicShareAction.id
                  )
                )
              }}
              onDeleteClick={(e) => {
                e.stopPropagation()
                setCampaignActionToDelete({
                  action: action.topicShareAction,
                  actionType: CampaignActionTypeEnum.TOPIC_SHARE_ACTION
                })
                setShowDeleteActionModal(true)
              }}
              onCopyClick={(e) => {
                e.stopPropagation()
                setCampaignActionToCopy({
                  action: action.topicShareAction,
                  actionType: CampaignActionTypeEnum.TOPIC_SHARE_ACTION
                })
                setShowCopyActionModal(true)
              }}
            />
          </div>
        </div>
      )
    }
    if (action.pathwayShareAction) {
      return (
        <div className="CampaignActions__item">
          <CampaignActionTime
            timeWithTimezone={time}
            smartSchedule={actualAction.automatic_time_of_day}
          />
          <div
            key={action.pathwayShareAction.id}
            className="CampaignActions__action"
          >
            <CampaignPathwayShareAction
              pathwayShareAction={action.pathwayShareAction}
              onEditClick={() => {
                navigateTo(
                  linkBuilder.campaignPathwayShareAction(
                    campaign.id,
                    action.pathwayShareAction.id
                  )
                )
              }}
              onDeleteClick={(e) => {
                e.stopPropagation()
                setCampaignActionToDelete({
                  action: action.pathwayShareAction,
                  actionType: CampaignActionTypeEnum.PATHWAY_SHARE_ACTION
                })
                setShowDeleteActionModal(true)
              }}
              onCopyClick={(e) => {
                e.stopPropagation()
                setCampaignActionToCopy({
                  action: action.pathwayShareAction,
                  actionType: CampaignActionTypeEnum.PATHWAY_SHARE_ACTION
                })
                setShowCopyActionModal(true)
              }}
            />
          </div>
        </div>
      )
    }
    if (action.certificationShareAction) {
      return (
        <div className="CampaignActions__item">
          <CampaignActionTime
            timeWithTimezone={time}
            smartSchedule={actualAction.automatic_time_of_day}
          />
          <div
            key={action.certificationShareAction.id}
            className="CampaignActions__action"
          >
            <CampaignCertificationShareAction
              certificationShareAction={action.certificationShareAction}
              onEditClick={() => {
                navigateTo(
                  linkBuilder.campaignCertificationShareAction(
                    campaign.id,
                    action.certificationShareAction.id
                  )
                )
              }}
              onDeleteClick={(e) => {
                e.stopPropagation()
                setCampaignActionToDelete({
                  action: action.certificationShareAction,
                  actionType: CampaignActionTypeEnum.CERTIFICATION_SHARE_ACTION
                })
                setShowDeleteActionModal(true)
              }}
              onCopyClick={(e) => {
                e.stopPropagation()
                setCampaignActionToCopy({
                  action: action.certificationShareAction,
                  actionType: CampaignActionTypeEnum.CERTIFICATION_SHARE_ACTION
                })
                setShowCopyActionModal(true)
              }}
            />
          </div>
        </div>
      )
    }
    if (action.surveyShareAction) {
      return (
        <div className="CampaignActions__item">
          <CampaignActionTime
            timeWithTimezone={time}
            smartSchedule={actualAction.automatic_time_of_day}
          />
          <div
            key={action.surveyShareAction.id}
            className="CampaignActions__action"
          >
            <CampaignSurveyShareAction
              surveyShareAction={action.surveyShareAction}
              onEditClick={() => {
                navigateTo(
                  linkBuilder.campaignSurveyShareAction(
                    campaign.id,
                    action.surveyShareAction.id
                  )
                )
              }}
              onDeleteClick={(e) => {
                e.stopPropagation()
                setCampaignActionToDelete({
                  action: action.surveyShareAction,
                  actionType: CampaignActionTypeEnum.SURVEY_SHARE_ACTION
                })
                setShowDeleteActionModal(true)
              }}
              onCopyClick={(e) => {
                e.stopPropagation()
                setCampaignActionToCopy({
                  action: action.surveyShareAction,
                  actionType: CampaignActionTypeEnum.SURVEY_SHARE_ACTION
                })
                setShowCopyActionModal(true)
              }}
            />
          </div>
        </div>
      )
    }
    if (action.message) {
      return (
        <div className="CampaignActions__item">
          <CampaignActionTime
            timeWithTimezone={time}
            smartSchedule={actualAction.automatic_time_of_day}
          />

          <div key={action.message.id} className="CampaignActions__action">
            <CampaignMessageAction
              message={action.message}
              onEditClick={() => {
                navigateTo(
                  linkBuilder.campaignMessage(campaign.id, action.message.id)
                )
              }}
              onDeleteClick={(e) => {
                e.stopPropagation()
                setCampaignActionToDelete({
                  action: action.message,
                  actionType: CampaignActionTypeEnum.MESSAGE
                })
                setShowDeleteActionModal(true)
              }}
              onCopyClick={(e) => {
                e.stopPropagation()
                setCampaignActionToCopy({
                  action: action.message,
                  actionType: CampaignActionTypeEnum.MESSAGE
                })
                setShowCopyActionModal(true)
              }}
            />
          </div>
        </div>
      )
    }
    return null
  }

  const renderImmediateListOfActions = () => {
    const actions = [
      ...campaign.topicShareActions.map((action) => {
        return {
          topicShareAction: action,
          key: `${action.__typename}-${action.id}`
        }
      }),
      ...campaign.pathwayShareActions.map((action) => {
        return {
          pathwayShareAction: action,
          key: `${action.__typename}-${action.id}`
        }
      }),
      ...campaign.certificationShareActions.map((action) => {
        return {
          certificationShareAction: action,
          key: `${action.__typename}-${action.id}`
        }
      }),
      ...campaign.messageActions.map((action) => {
        return {
          message: action,
          key: `${action.__typename}-${action.id}`
        }
      }),
      ...campaign.emailActions.map((action) => {
        return {
          email: action,
          key: `${action.__typename}-${action.id}`
        }
      }),
      ...campaign.surveyShareActions.map((action) => {
        return {
          surveyShareAction: action,
          key: `${action.__typename}-${action.id}`
        }
      }),
      ...campaign.banners.map((banner) => {
        return {
          banner: banner,
          key: `banner-${banner.id}`
        }
      })
    ].map((action) => <Action key={action.key} time={null} action={action} />)

    return actions
  }

  const renderFixedOrRelativeListOfActions = () => {
    return (
      <div className="CampaignActions__groups">
        {Object.keys(actionsTimeline)
          .sort((a, b) => {
            if (isCampaignFixed(campaign)) {
              return b < a ? 1 : -1
            } else if (isCampaignRelative(campaign)) {
              return parseInt(b, 10) < parseInt(a, 10) ? 1 : -1
            } else {
              throw Error(
                `cannot sort campaign of type ${campaign.schedule_type}`
              )
            }
          })
          .map((day) => {
            const wrongScheduleType = isScheduleTypeWrong(day)
            return (
              <div className="CampaignActions__group" key={day}>
                <div
                  className={`CampaignActions__dayIndicator ${
                    wrongScheduleType ? 'reschedule-required' : ''
                  }`}
                >
                  <Day day={day} wrongScheduleType={wrongScheduleType} />
                </div>
                <div className={'CampaignActions__dayItems'}>
                  {Object.keys(actionsTimeline[day])
                    .sort()
                    .map((time) => {
                      return (
                        <div className="CampaignActions__timeItems" key={time}>
                          {actionsTimeline[day][time].map((action, i) => {
                            return (
                              <Action
                                key={i}
                                time={i === 0 ? time : null}
                                action={action}
                              />
                            )
                          })}
                        </div>
                      )
                    })}
                </div>
              </div>
            )
          })}
      </div>
    )
  }

  const className = isCampaignImmediate(campaign)
    ? 'CampaignActions CampaignActions--immediate'
    : 'CampaignActions'

  const isAddNewActionAllowed = () => {
    if (wasCampaignDeactivated) {
      return false
    }

    if (isCampaignImmediate(campaign) && campaign.is_active) {
      return false
    }

    return true
  }

  return (
    <section className={className}>
      <PageHeader
        showBackButton={false}
        title={
          <Flex>
            <IconEnergy
              css={css`
                margin: 0 24px 0 32px;
              `}
            />
            <Box>
              <Trans>Actions</Trans>
            </Box>
          </Flex>
        }
        level={2}
        controls={
          isAddNewActionAllowed() ? (
            <ButtonPrimary onClick={() => setShowCreateActionModal(true)}>
              <Trans>Add an action</Trans>
            </ButtonPrimary>
          ) : null
        }
      />

      <p className="CampaignActions__subheader">
        <Trans>Add and schedule actions for this campaign</Trans>
      </p>

      {isWrongScheduleType && (
        <p className="CampaignActions__subheader reschedule-required">
          <b>
            <Trans>
              Some actions are configured with an incorrect schedule type.
            </Trans>{' '}
          </b>
          <br />
          {campaign.is_active && (
            <Trans>
              Actions with incorrect dates can not be scheduled and processed.
            </Trans>
          )}
          {!campaign.is_active && (
            <Trans>
              This Campaign can not be activated until these actions have been
              rescheduled.
            </Trans>
          )}
        </p>
      )}

      {!isLoading && countOfActionsInCampaign(campaign) === 0 && (
        <div className="no-items">
          <img src={IconEmptyCampaigns} alt={t`Empty campaigns`} />
          <h3>
            <Trans>No Actions found.</Trans>
          </h3>
        </div>
      )}

      {isLoading && <Loader />}

      {isCampaignImmediate(campaign) && renderImmediateListOfActions()}
      {(isCampaignFixed(campaign) || isCampaignRelative(campaign)) &&
        renderFixedOrRelativeListOfActions()}

      {campaign && showCreateActionModal && (
        <CreateCampaignActionModal
          show
          onHide={() => {
            setShowCreateActionModal(false)
          }}
          onCreate={() => {
            setShowCreateActionModal(false)
          }}
        />
      )}

      {campaign && showCopyActionModal && (
        <CopyCampaignActionModal
          campaignId={campaign.id}
          onHide={() => {
            setShowCopyActionModal(false)
          }}
          onCopy={async () => {
            await refetchCampaign()
            setShowCopyActionModal(false)
          }}
          itemToCopy={campaignActionToCopy}
        />
      )}

      {campaign && showDeleteActionModal && (
        <DeleteCampaignActionModal
          show
          campaignId={campaign.id}
          onHide={() => {
            setShowDeleteActionModal(false)
          }}
          onDelete={async () => {
            setIsDeleting(true)
            await refetchCampaign()
            setShowDeleteActionModal(false)
          }}
          itemToDelete={campaignActionToDelete}
        />
      )}
    </section>
  )
}

const createActionsTimeline = (campaign: SingleCampaign) => {
  const isFixedSchedule =
    isCampaignFixed(campaign) || isCampaignImmediate(campaign)

  const emailGroup = convertToLinearTimeline(
    campaign.emailActions,
    isFixedSchedule ? 'fixed_send_time' : 'send_at_day',
    isFixedSchedule ? null : 'send_at_time',
    'email'
  )
  const bannerGroup = convertToLinearTimeline(
    campaign.banners,
    isFixedSchedule ? 'fixed_show_time_start' : 'show_at_day',
    isFixedSchedule ? null : 'show_at_time',
    'banner'
  )
  const bannerHideGroup = convertToLinearTimeline(
    campaign.banners,
    isFixedSchedule ? 'fixed_show_time_end' : 'hide_at_day',
    isFixedSchedule ? null : 'hide_at_time',
    'bannerHide'
  )
  const topicShareGroup = convertToLinearTimeline(
    campaign.topicShareActions,
    isFixedSchedule ? 'fixed_send_time' : 'send_at_day',
    isFixedSchedule ? null : 'send_at_time',
    'topicShareAction'
  )
  const pathwayShareGroup = convertToLinearTimeline(
    campaign.pathwayShareActions,
    isFixedSchedule ? 'fixed_send_time' : 'send_at_day',
    isFixedSchedule ? null : 'send_at_time',
    'pathwayShareAction'
  )
  const certificationShareGroup = convertToLinearTimeline(
    campaign.certificationShareActions,
    isFixedSchedule ? 'fixed_send_time' : 'send_at_day',
    isFixedSchedule ? null : 'send_at_time',
    'certificationShareAction'
  )
  const surveyShareGroup = convertToLinearTimeline(
    campaign.surveyShareActions,
    isFixedSchedule ? 'fixed_send_time' : 'send_at_day',
    isFixedSchedule ? null : 'send_at_time',
    'surveyShareAction'
  )
  const messageGroup = convertToLinearTimeline(
    campaign.messageActions,
    isFixedSchedule ? 'fixed_send_time' : 'send_at_day',
    isFixedSchedule ? null : 'send_at_time',
    'message'
  )

  const timeline = {}
  _.mergeWith(timeline, emailGroup, concatItems)
  _.mergeWith(timeline, bannerGroup, concatItems)
  _.mergeWith(timeline, bannerHideGroup, concatItems)
  _.mergeWith(timeline, topicShareGroup, concatItems)
  _.mergeWith(timeline, pathwayShareGroup, concatItems)
  _.mergeWith(timeline, surveyShareGroup, concatItems)
  _.mergeWith(timeline, messageGroup, concatItems)
  _.mergeWith(timeline, certificationShareGroup, concatItems)

  return timeline
}

function concatItems(objValue, srcValue) {
  if (_.isArray(objValue)) {
    return objValue.concat(srcValue)
  }
}

function convertToLinearTimeline(items, dayAttrName, timeAttrName, type) {
  let groupedByDate
  const objectByType = items.map((item) => {
    return { [type]: item }
  })
  if (timeAttrName) {
    groupedByDate = _.groupBy(objectByType, (result) => {
      return result[type][dayAttrName]
    })
  } else {
    groupedByDate = _.groupBy(objectByType, (result) => {
      return dayjs(result[type][dayAttrName])
        .tz(result[type].timezone || dayjs.tz.guess())
        .format('YYYY-MM-DD')
    })
  }

  Object.entries(groupedByDate).forEach(([key, value]) => {
    // @ts-expect-error
    groupedByDate[key] = _.groupBy(value, (result: any) => {
      let time
      if (timeAttrName && result[type][timeAttrName]) {
        const [hours, minutes] = result[type][timeAttrName]
          .split(':')
          .map((n) => Number(n))
        time = dayjs().hour(hours).minute(minutes)
      } else {
        time = dayjs(result[type][timeAttrName ? timeAttrName : dayAttrName])
      }

      // Fixed campaign actions are using timezone.
      // Relative campaign actions does not use timezone. These are rendered without timezone, just plain time.
      if (result[type].timezone) {
        const timeWithTz = time.tz(result[type].timezone || dayjs.tz.guess())

        // We are sending empty string for invalid date - null and undefined will get converted to 'null' and 'undefined'
        // when assigned to timeline object as keys
        return timeWithTz.isValid() ? timeWithTz.format('HH:mm Z') : ''
      } else {
        return time.format('HH:mm')
      }
    })
  })
  return groupedByDate
}

export { createActionsTimeline }
